interface GoogleEvent {
    event: string;
    value?: unknown;
}

export class GoogleAnalyticsService {
    /**
     * Track a custom event
     * @param eventName The GA event name
     * @param params Optional event parameters
     */
    static trackEvent(eventName: string, params?: GoogleEvent['value']) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            value: params,
        });
    }
}
